import {TrashIcon} from '@heroicons/react/24/outline';
import {Button} from '../../components/Button';

interface DangerZoneSectionProps {
  onDeleteAccount: () => void;
}

/**
 * Presentational component for the danger zone section.
 * Shows delete account warning and button.
 */
export const DangerZoneSection = ({ onDeleteAccount }: DangerZoneSectionProps) => {
  return (
    <div className="bg-error-subtle rounded-3xl shadow-xl border border-error overflow-hidden">
      <div className="px-6 py-5 border-b border-error flex items-center">
        <TrashIcon className="h-5 w-5 text-error mr-3" />
        <h3 className="text-lg  text-error">Danger Zone</h3>
      </div>
      <div className="p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-sm text-error">
            <p className="">Delete your account</p>
            <p className="mt-1 opacity-80">
              Once you delete your account, there is no going back. Please be certain.
            </p>
          </div>
          <Button
            type="button"
            variant="destructive"
            onClick={onDeleteAccount}
            className="whitespace-nowrap"
          >
            Delete Account
          </Button>
        </div>
      </div>
    </div>
  );
};
